module.exports = __webpack_public_path__ + "img/vertical_7_3_8003.bc5769be.png";